import { Component, OnInit, Inject } from '@angular/core';
import { AppService } from './../../../shared/services/geral/app.service';
import { NgForm, NgControl, NgModel } from '@angular/forms';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { DOCUMENT } from '@angular/common';
import { InterceptorSkipHeader } from '../assinatura-interna/assinatura-interna/assinatura-interna.component';
import { LoginService } from 'src/app/modules/shared/services/login/login.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public titulo_entrar: string = "";
  public titulo_trocar: string = "";
  public titulo_solicitar: string = "";
  public ipAddress: string = "";
  

  public currentAno: string = "";

  constructor(private http: HttpClient, public svc: AppService, private router: Router, private activatedRoute: ActivatedRoute, @Inject(DOCUMENT) private _document: HTMLDocument, public svcLogin: LoginService) {
    this.svc.sbGetTraducaoAuto("login").subscribe((resp) => {
      this.titulo_entrar = resp.titulo_entrar;
      this.titulo_trocar = resp.titulo_trocar;
      this.titulo_solicitar = resp.titulo_solicitar;
      this.tipoForm = this.titulo_entrar;

    });
  }

  public painel: number = 0;
  public senhaInvalida: boolean = false;
  public tipoForm: string = "";
  public idioma: string = "pt";

  public sbMudarIdioma(): void {
    this.svc.sbSelecionarIdioma(this.idioma);
    setTimeout(function () {
      Swal.fire({
        title: "",
        text: "Pronto!",
        icon: "success",
        timer: 1000,
        showCancelButton: false,
        showConfirmButton: false
      });
    }, 200);
  }

  public sbMudarForm(tipo: number, f: NgForm[]) {
    f.forEach(function (item) {
      item.reset();
    });

    switch (tipo) {
      case 0:
        this.tipoForm = this.titulo_entrar;
        break;
      case 1:
        this.tipoForm = this.titulo_trocar;
        break;
      case 2:
        this.tipoForm = this.titulo_solicitar;
        break;
    }

    this.senhaInvalida = false;
    this.painel = tipo;
  }

  public loginModel: any = {
    usuario: "",
    senha: ""
  };

  // public trocarSenha: any = {
  //   usuario: "",
  //   senha_anterior: "",
  //   nova_senha: "",
  //   confirmar_senha: ""
  // };


  public trocarSenha: any = {
    login: "",
    token: "",
    nova_senha: "",
    confirmar_senha: "",
    email : ""
  };

  public esquecerSenha: any = {
    usuario: ""
  }


  public sbCheckPassword(f: NgForm) {
    const password = this.trocarSenha.nova_senha;
    const confirm_new_password = this.trocarSenha.confirmar_senha;

    if (confirm_new_password !== "") {
      if (confirm_new_password !== password) {
        this.senhaInvalida = true;
        f.controls["confirm_senhaTS"].setErrors({ 'incorrect': true });
      } else {
        f.controls["confirm_senhaTS"].setErrors(null);
        this.senhaInvalida = false;
      }
    } else {
      this.senhaInvalida = false;
    }
  }

  // public getIPAddress() {
  //   var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
  //   this.http.get("https://jsonip.com", { headers: headers }).subscribe((res: any) => {
  //     this.ipAddress = res.ip;
  //   });
  // }

  public getIPAddress() {
    var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
    this.http.get("https://api64.ipify.org?format=json", { headers: headers }).subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  public sbProcessarTS(f: NgForm) {
    //Verifica se o FOrmulário está Válido
    if (f.valid) {
      this.svc.AlteraSenha({
        "usuario": this.trocarSenha.usuario,
        "novaSenha": this.trocarSenha.nova_senha,
        "antigaSenha": this.trocarSenha.senha_anterior
      });
    } else {
      //Marca todos os campos como Inválidos
      (<any>Object).values(f.controls).forEach(control => {
        control.markAsTouched();
      });
      this.svc.sbExibirNotificacao("warning", "Atenção!", "Verifique os Campos Marcados!");
    }
  }

  public sbProcessarTP(f: NgForm) {
    //Verifica se o FOrmulário está Válido
    if (f.valid) {
      let that = this;
      this.svc.obterXML();
      this.svc.retornoXML().subscribe({
        next: (resp: any) => {
          if (resp != null) {

            this.loginModel["ip"] = this.ipAddress;
            this.svc.LoginPesquisar(this.loginModel);
            this.svc.LoginEncontrado().subscribe({
              next: (resp: any) => {
                if (resp != null) {
                  setTimeout(function () {
                    that.router.navigate([{
                      outlets: {
                        sidebar: ['menus'],
                        primary: ['monitor-processos']
                      }
                    }], { skipLocationChange: true });
                  }, 2000);
                }
              }
            });
          }
        }
      });
    } else {
      //Marca todos os campos como Inválidos
      (<any>Object).values(f.controls).forEach(control => {
        control.markAsTouched();
      });
      this.svc.sbExibirNotificacao("warning", "Atenção!", "Usuário e Senha Devem ser Preenchidos!");
    }
  }

  public sbProcessarNS(f: NgForm) {
    if (f.valid) {
      this.svc.GeraNovaSenha({
        "usuario": this.esquecerSenha.usuario
      });
    } else {
      //Marca todos os campos como Inválidos
      (<any>Object).values(f.controls).forEach(control => {
        control.markAsTouched();
      });
      this.svc.sbExibirNotificacao("warning", "Atenção!", "Verifique os Campos Marcados!");
    }
  }


  public sbObterTokenRecuperaSenha(f: NgForm) {
    try {
      if (f.valid) {
        this.svcLogin.spinTrocarSenhaGlobal = true;
        this.svc.TrocarSenhaObterTokenPesquisar(this.trocarSenha);
        this.svc.TokenEncontrado().subscribe({
          next: (resp: any) => {
           if (resp != null) {
              this.painel = 1;
              this.svcLogin.spinTrocarSenhaGlobal = false;
            }
            // else {
            //   this.svc.sbExibirNotificacao("error", "Atenção!", "Algo deu errado, por favor entre em contato com o Suporte!");
            //   this.spinTrocarSenha = false;
            //    this.svcLogin.spinTrocarSenhaGlobal = false;
            // }
          },
        });
      } else {
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
        this.svc.sbExibirNotificacao("warning", "Atenção!", "Verifique os Campos Marcados!");
      }

    } catch (e) {
      this.svc.sbExibirAlerta("error", "Oops...", "Algo deu errado, por favor entre em contato com o Suporte!");
      this.svcLogin.spinTrocarSenhaGlobal = false;
    }
  }

  // public sbTrocarSenha(f: NgForm) {
  //   if (f.valid) {
  //     this.svc.TrocarSenhaPesquisar(this.trocarSenha);
  //     this.svc.NovaSenhaCriada().subscribe({
  //       next: (resp: any) => {
  //         console.log(typeof resp);
  //         console.log(typeof null);
  //         if (resp != null) {
  //           if(resp == "OK"){
  //             console.log(1);
  //             this.svc.sbExibirNotificacao("success", "Senha alterada!", "Senha alterada com sucesso!!");
  //             this.painel = 0;
  //           }
  //           else{

  //             this.svc.sbExibirNotificacao("error", "Atenção!", "Algo deu errado, por favor entre em contato com o Suporte!");
  //           }

  //         }
  //         else{

  //           this.svc.sbExibirNotificacao("error", "Atenção!", "Algo deu errado, por favor entre em contato com o Suporte!");
  //         }
  //         console.log(resp);
  //       }
  //     });
  //   } else {
  //     //Marca todos os campos como Inválidos
  //     (<any>Object).values(f.controls).forEach(control => {
  //       control.markAsTouched();
  //     });
  //     this.svc.sbExibirNotificacao("warning", "Atenção!", "Verifique os Campos Marcados!");
  //   }
  // }

  public sbTrocarSenha(f: NgForm) {
    try {
      if (f.valid) {
        this.svcLogin.spinTrocarSenhaGlobal = true;
        this.svc.TrocarSenhaPesquisar(this.trocarSenha);
        this.svc.NovaSenhaCriada().subscribe((resp) => {
           if (resp != null) {
            this.svc.sbExibirNotificacao("success", "Senha alterada!", "Senha alterada com sucesso!!");
            this.painel = 0;
            this.svcLogin.spinTrocarSenhaGlobal = false
            this.tipoForm = this.titulo_entrar;
          }
          else {
            this.svc.sbExibirNotificacao("error", "Atenção!", "Algo deu errado, por favor entre em contato com o Suporte!");
            // this.spinTrocarSenha = false;
          }
        });
      } else {
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
        
        this.svc.sbExibirNotificacao("warning", "Atenção!", "Verifique os Campos Marcados!");

      }
    } catch (e) {
      this.svcLogin.spinTrocarSenhaGlobal = false;
      this.svc.sbExibirAlerta("error", "Oops...", "Algo deu errado, por favor entre em contato com o Suporte!");
      
    }
  }


  ngOnInit() {
    try {
      this.currentAno = new Date().getFullYear().toString();

      this.getIPAddress();
      this.svc.obterXML();
      this.svc.retornoXML().subscribe({
        next: (resp: any) => {
          if (resp != null) {
            this._document.getElementById('appFavicon').setAttribute('href', resp.fiveIcon);
            this._document.title = resp.titulo;
          }
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", "Oops...", "Algo deu errado, por favor entre em contato com o Suporte!")
    }
  }
}
